// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__w8ey_","col":"styles_col__14Cf_","actions":"styles_actions__e7Y21","conflict":"styles_conflict__1gQh2"};